import React from 'react';

const Circle = () => {
  return <div className="!w-2 !h-2 rounded-full bg-grasp" />;
};

export default Circle;
